import ListItem from '@material-ui/core/ListItem';
import {withStyles} from '@material-ui/core';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ReactGA from 'react-ga';
import {I18n} from 'react-redux-i18n';
import {updateConstrainedFilters} from '../libraryFilterActions';
import {hasAccess} from '../../app/user';

const styles = {
  label: {
    fontSize: '1rem'
  }
};

export class ConstrainedFilters extends React.Component {
  static propTypes = {
    updateFilters: PropTypes.func.isRequired,
    onDemand: PropTypes.bool,
    reviewed: PropTypes.bool,
    reviewedComplete: PropTypes.bool,
    unreviewed: PropTypes.bool,
    coachingCompleted: PropTypes.bool,
    flagged: PropTypes.bool,
    tagged: PropTypes.bool
  }

  static defaultProps = {
    onDemand: false,
    reviewed: false,
    reviewedComplete: false,
    unreviewed: false,
    coachingCompleted: false,
    flagged: false,
    tagged: false
  }

  handleGA = (gaAction, checked) => {
    ReactGA.event({
      category: 'Library Filter',
      action: gaAction,
      label: checked ? 'Switch On' : 'Switch Off'
    });
  }

  handleOnDemand = (event, checked) => {
    const newState = {onDemand: checked};

    this.handleGA('On Demand', checked);

    this.updateFilters(newState);
  }

  handleReviewed = (event, checked) => {
    let newState = {reviewed: checked};
    if (checked) {
      newState = {
        ...newState,
        unreviewed: false
      };
    }

    this.handleGA('Reviewed', checked);

    this.updateFilters(newState);
  }

  handleReviewedComplete = (event, checked) => {
    let newState = {reviewedComplete: checked};
    if (checked) {
      newState = {
        ...newState,
        unreviewed: false,
        coachingCompleted: false,
        tagged: false
      };
    }

    this.handleGA('Reviewed - Complete', checked);

    this.updateFilters(newState);
  }

  handleUnreviewed = (event, checked) => {
    let newState = {unreviewed: checked};
    if (checked) {
      newState = {
        ...newState,
        reviewed: false,
        reviewedComplete: false
      };
    }

    this.handleGA('Unreviewed', checked);

    this.updateFilters(newState);
  }

  handleCoachingCompleted = (event, checked) => {
    let newState = {coachingCompleted: checked};
    if (checked) {
      newState = {
        ...newState,
        reviewedComplete: false,
        tagged: false
      };
    }

    this.handleGA('Coaching Completed', checked);

    this.updateFilters(newState);
  }

  handleLocked = (event, checked) => {
    const newState = {locked: checked};

    this.handleGA('Locked ', checked);

    this.updateFilters(newState);
  }

  handleFlagged = (event, checked) => {
    let newState = {flagged: checked};
    if (checked) {
      newState = {
        ...newState
      };
    }

    this.handleGA('Flagged', checked);

    this.updateFilters(newState);
  }

  handleTagged = (event, checked) => {
    let newState = {tagged: checked};
    if (checked) {
      newState = {
        ...newState,
        reviewedComplete: false,
        coachingCompleted: false
      };
    }

    this.handleGA('Tagged', checked);

    this.updateFilters(newState);
  }

  updateFilters = newFilters => {
    const {
      onDemand,
      reviewed,
      reviewedComplete,
      unreviewed,
      locked,
      coachingCompleted,
      flagged,
      tagged
    } = this.props;

    this.props.updateFilters({
      onDemand,
      reviewed,
      locked,
      reviewedComplete,
      unreviewed,
      coachingCompleted,
      flagged,
      tagged,
      ...newFilters
    });
  }

  render() {
    const {classes, isAdmin} = this.props;
    return (
      <ListItem>
        <Table className="filtertable">
          <TableBody>
            <TableRow>
              <TableCell>
                {I18n.t('filter.onDemand')}
              </TableCell>
              <TableCell>
                <Switch
                  checked={this.props.onDemand}
                  onChange={this.handleOnDemand}
                  name="onDemand"
                  className="filterswitch"
                  id="filterOnDemand"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {I18n.t('filter.flagged')}
              </TableCell>
              <TableCell>
                <Switch
                  checked={this.props.flagged}
                  onChange={this.handleFlagged}
                  name="flagged"
                  className="filterswitch"
                  id="filterFlagged"
                />
              </TableCell>
            </TableRow>
            {isAdmin && (
              <TableRow>
                <TableCell>
                  {I18n.t('filter.locked')}
                </TableCell>
                <TableCell>
                  <Switch
                    checked={this.props.locked}
                    onChange={this.handleLocked}
                    name="locked"
                    className="filterswitch"
                    id="lockedFlagged"
                  />
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>
                <strong className={classes.label}>
                  {I18n.t('filter.reviews.label')}
                </strong>
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                {I18n.t('filter.reviews.unReviewed')}
              </TableCell>
              <TableCell>
                <Switch
                  checked={this.props.unreviewed}
                  onChange={this.handleUnreviewed}
                  name="unreviewed"
                  className="filterswitch"
                  id="filterUnreviewed"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {I18n.t('filter.reviews.tagged')}
              </TableCell>
              <TableCell>
                <Switch
                  checked={this.props.tagged}
                  onChange={this.handleTagged}
                  name="tagged"
                  className="filterswitch"
                  id="filterTagged"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {I18n.t('filter.reviews.reviewed')}
              </TableCell>
              <TableCell>
                <Switch
                  checked={this.props.reviewed}
                  onChange={this.handleReviewed}
                  name="reviewed"
                  className="filterswitch"
                  id="filterReviewed"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {I18n.t('filter.reviews.reviewedComplete')}
              </TableCell>
              <TableCell>
                <Switch
                  checked={this.props.reviewedComplete}
                  onChange={this.handleReviewedComplete}
                  name="reviewedComplete"
                  className="filterswitch"
                  id="filterReviewedComplete"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {I18n.t('filter.reviews.coachingComplete')}
              </TableCell>
              <TableCell>
                <Switch
                  checked={this.props.coachingCompleted}
                  onChange={this.handleCoachingCompleted}
                  name="coachingCompleted"
                  className="filterswitch"
                  id="filterCoachingComplete"
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </ListItem>
    );
  }
}
const mapStateToPros = state => {
  const isAdmin = hasAccess([
    'videoIntelligenceAdmin',
    'changeCustomer',
    'videoIntelligenceInternal'
  ]);
  return {...state.libraryFilters.constrainedFilters, isAdmin};
};

const dispatcherToProps = (dispatch, ownProps) => ({
  updateFilters: filters => dispatch(updateConstrainedFilters(filters)),
  ...ownProps
});

const styled = withStyles(styles)(ConstrainedFilters);
export default connect(mapStateToPros, dispatcherToProps)(styled);
